var map = {
	"./en-ca.json": [
		8781,
		[
			781
		]
	],
	"./en-us.json": [
		1813,
		[
			813
		]
	],
	"./es-mx.json": [
		1797,
		[
			797
		]
	],
	"./fr-ca.json": [
		4348,
		[
			348
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 327;
module.exports = webpackAsyncContext;